var _circle, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleLimeCelebration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#E3FB94"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-circle-lime--celebration_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M3.5 3.231h20v20h-20z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-circle-lime--celebration_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.168 21.565L9.335 9.898l7.5 7.5-11.667 4.167zm2.75-2.75l5.875-2.084-3.792-3.791-2.083 5.875zm7.708-5.125l-.875-.875 4.667-4.667c.444-.444.98-.667 1.604-.667.625 0 1.16.223 1.604.667l.5.5-.875.875-.5-.5a.99.99 0 00-.729-.292.99.99 0 00-.729.292l-4.667 4.667zm-3.333-3.334l-.875-.875.5-.5a.964.964 0 00.292-.708.964.964 0 00-.292-.708l-.542-.542.875-.875.542.542c.444.444.667.972.667 1.583s-.223 1.139-.667 1.583l-.5.5zm1.667 1.667l-.875-.875 3-3a.99.99 0 00.291-.729.99.99 0 00-.291-.73L14.75 5.357l.875-.875 1.334 1.334c.444.444.666.979.666 1.604 0 .625-.222 1.16-.666 1.604l-3 3zm3.333 3.333l-.875-.875 1.333-1.333c.445-.444.98-.667 1.604-.667.625 0 1.16.223 1.605.667l1.333 1.333-.875.875-1.333-1.333a.99.99 0 00-.73-.292.99.99 0 00-.729.292l-1.333 1.333z",
    fill: "#1C1B1F"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle-lime--celebration-8954f00dd4a977e067c4b9d4ced51e3b.svg";
export { SvgIconCircleLimeCelebration as Component };